import { ResponsiveContainer, styled } from '@arpeggi/ui'
import { BigFlare } from './Flare'

const Root = styled('div', {
  padding: '24px 0px',
  paddingBottom: '104px',
  overflow: 'hidden',
  position: 'relative'
})

const Flare1 = styled(BigFlare, {
  visibility: 'hidden',
  '@tablet': {
    visibility: 'visible'
  },
  position: 'absolute',
  top: '80px',
  left: '-90px'
})

const Flare2 = styled(BigFlare, {
  visibility: 'hidden',
  '@tablet': {
    visibility: 'visible'
  },
  position: 'absolute',
  top: '120px',
  right: '-200px',
  pointerEvents: 'none'
})

const Content = styled(ResponsiveContainer, {
  position: 'relative',
  background:
    'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 5%, #FFFFFF 95%, rgba(255, 255, 255, 0) 100%);'
})

const Column = styled('div', {
  display: 'flex',
  flexDirection: 'Column',
  flex: '1',
  variants: {
    wide: {
      true: {
        flex: '1.5'
      }
    }
  }
})

export const Section = { Root, Content, Flare1, Flare2, Column }
